import {
  usePatchSaleVehicleSalePresetMutation,
  usePatchSaleVehicleSourceCodeMutation,
} from '@dms/api/vehicle';
import {handleApiError} from '@dms/shared';

import {Nullish} from 'shared/web';

interface PatchSaleFields {
  vehicleSourceCodeId: string | Nullish;
  salePresetId: string | Nullish;
}

export function usePatchSaleFields() {
  const [patchSaleVehicleSourceCode, {isLoading: isPatchSaleVehicleSourceCodeLoading}] =
    usePatchSaleVehicleSourceCodeMutation();
  const [patchSaleVehicleSalePreset, {isLoading: isPatchSaleVehicleSalePresetLoading}] =
    usePatchSaleVehicleSalePresetMutation();

  const patchSaleVehicleFields = (vehicleId: string, fields: PatchSaleFields) => {
    const promises = [];
    if (fields.vehicleSourceCodeId !== undefined) {
      promises.push(
        patchSaleVehicleSourceCode({
          vehicleId,
          patchSaleVehicleSourceCodeRequestBody: {
            vehicleSourceCodeId: fields.vehicleSourceCodeId,
          },
        })
          .unwrap()
          .catch(handleApiError)
      );
    }
    if (fields.salePresetId !== undefined) {
      promises.push(
        patchSaleVehicleSalePreset({
          vehicleId,
          patchSaleVehicleSalePresetRequestBody: {
            salePresetId: fields.salePresetId,
          },
        })
          .unwrap()
          .catch(handleApiError)
      );
    }
    return Promise.all(promises);
  };

  return [
    patchSaleVehicleFields,
    {isLoading: isPatchSaleVehicleSourceCodeLoading || isPatchSaleVehicleSalePresetLoading},
  ] as const;
}
